module.exports = __webpack_public_path__ + "static/img/show_pic4.f37aa778.png";